import AdFormatIcon from '../../../components/Icons/AdFormatIcon';

const AdFormatHeader = () => {
  return (
    <div className='flex w-full py-5 px-4 justify-between border-b'>
      <div className='flex flex-1 gap-3 items-center justify-start'>
        <AdFormatIcon />
        <h3 className='text-lg text-[#2E2C34] font-semibold'>Ad Format</h3>
      </div>
    </div>
  );
};

export default AdFormatHeader;
